import React, { Component } from "react";
import styles from "./unitsTaskTripMap.module.scss";
import { MapContainer, TileLayer, Marker, Circle, MapConsumer, Popup, GeoJSON } from "react-leaflet";
import L from "leaflet";
import { withMonitoringTaskTrips } from "../../../../shared/containers/containerLogisticMonitoringsTaskTrips";
import { withMapControl } from "../../../../shared/containers/containerMapControl";
import { withAppState } from "../../../../shared/containers/containerAppState";
import TopRightMapControl from "../../../LayerMapCotrol/TopRightMapControl";
import BaseLayerMapControl from "../../../LayerMapCotrol/BaseLayerMapControl";
import TooltipWrapper from "../../../../shared/items/contols/tooltipWrapper";
import LayersIcon from "@mui/icons-material/Layers";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import AntPath from "../../../AntPath/AntPath";
import getDates from "../../../../shared/services/date.service";
import { ControlPointIcon } from "../../ControlPoints/ControlPointIcon";
import { states } from "../../../../reducers/queriesStates";
import MapMarkerTaskTrip from "./MapMarkerTaskTrip";

class UnitsTaskTripMap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      maxLocation: null,
      nimLocation: null,
      isOverlayerControlOpen: false,
      isControlPointsView: true,
      isRouteGeometryView: true,
      viewUnits: [],
    };
  }

  componentDidMount() {
    const { onGetMonitoringsTaskTrip } = this.props;
    const taskTripId = window.location.pathname.replace("/logistic/monitorings", "").replace("/", "").replace("settings", "");

    if (taskTripId !== "" && taskTripId !== "/") {
      onGetMonitoringsTaskTrip({ id: taskTripId });
    }
  }

  componentDidUpdate(prevProps) {
    const { monitoringTaskTrip, monitoringTaskTripDataState } = this.props;

    if (
      (monitoringTaskTripDataState === states.READY && prevProps.monitoringTaskTripDataState === states.REQUEST) ||
      (monitoringTaskTrip !== null && prevProps.monitoringTaskTrip === null) ||
      (monitoringTaskTrip !== null && prevProps.monitoringTaskTrip.id !== monitoringTaskTrip.id)
    ) {
      const controlPoints = [];

      monitoringTaskTrip.units.forEach((unit) => {
        unit.routes.forEach((route) => {
          route.controlPoints.forEach((controlPoint) => {
            controlPoints.push(controlPoint);
          });
        });
      });

      const longitudes = controlPoints.map((x) => {
        return x.longitude;
      });

      const latitudes = controlPoints.map((x) => {
        return x.latitude;
      });

      const maxLocation = {
        lon: Math.max(...longitudes),
        lng: Math.max(...latitudes),
      };

      const minLocation = {
        lon: Math.min(...longitudes),
        lng: Math.min(...latitudes),
      };

      this.setState({ maxLocation, minLocation });

      let isViewUnit = true;

      const _viewUnits = monitoringTaskTrip.units.map((unit) => {
        const viewUnit = {
          isView: isViewUnit,
          id: unit.id,
          title: unit.title,
          registerNumber: unit.registerNumber,
        };

        isViewUnit = false;
        return viewUnit;
      });

      this.setState({ viewUnits: _viewUnits });
    }
  }

  onChangeUnitView(id, isView) {
    const { viewUnits } = this.state;

    viewUnits.forEach((unit) => {
      if (unit.id === id) {
        unit.isView = isView;
      }
    });

    this.setState({ viewUnits });
  }

  getIcon(color, number) {
    return L.divIcon({
      html: `<div style="display: flex; color: ${color}">${ControlPointIcon.getIcon(color)} <div><b> ${number}</b></div></div>`,
      className: "svg-icon",
      iconSize: [26, 26],
      iconAnchor: [6, 25],
    });
  }

  render() {
    const { mapBaseLayer, isSideBarOpen, monitoringTaskTrip } = this.props;

    const { isRouteGeometryView, isOverlayerControlOpen, isControlPointsView, viewUnits, maxLocation, minLocation } = this.state;
    const height = window.innerHeight - 70;

    if (monitoringTaskTrip === null) return <div></div>;

    let orderCountControlPoint = 1;

    return (
      <div>
        <MapContainer
          key={`${monitoringTaskTrip.id} ${mapBaseLayer.name}  ${isSideBarOpen}`}
          center={[53, 27]}
          zoom={15}
          maxZoom={mapBaseLayer.maxZoom}
          minZoom={3}
          crs={mapBaseLayer.crs}
          zoomControl={true}
          attributionControl={false}
          doubleClickZoom={true}
          scrollWheelZoom={true}
          dragging={true}
          animate={true}
          easeLinearity={0.35}
          style={{ height: `${height}px` }}
        >
          <MapConsumer>
            {(map) => {
              if (minLocation !== undefined && minLocation !== null && minLocation.lng !== Infinity) {
                map.fitBounds(
                  new L.latLngBounds([new L.latLng(minLocation.lng, minLocation.lon), new L.latLng(maxLocation.lng, maxLocation.lon)]).pad(
                    0.2
                  )
                );

                this.setState({ minLocation: null, maxLocation: null });
              }

              return null;
            }}
          </MapConsumer>

          {mapBaseLayer.url.map((_url, index) => {
            return <TileLayer key={mapBaseLayer.name + index} url={_url} updateWhenIdle={true} maxZoom={mapBaseLayer.maxZoom} />;
          })}

          {isRouteGeometryView
            ? monitoringTaskTrip.units.map((unit) => {
                const isView = viewUnits.some((x) => {
                  return x.id === unit.id && x.isView;
                });

                if (!isView || unit.geoJsonTrip.tripGeometries === null) return null;

                return (
                  <div key={unit.id}>
                    {unit.geoJsonTrip.tripGeometries.routes.map((routeGeometry, index) => {
                      return <GeoJSON key={unit.id + index} data={routeGeometry.geometry} color={"black"} weight={1} />;
                    })}
                  </div>
                );
              })
            : null}

          {monitoringTaskTrip.units.map((unit) => {
            if (!isControlPointsView) return null;

            const isView = viewUnits.some((x) => {
              return x.id === unit.id && x.isView;
            });

            if (!isView || unit.mapPositions.routes.length === 0) return null;

            return (
              <div key={unit.id}>
                {unit.routes.map((route) => {
                  return (
                    <div key={route.id}>
                      {route.controlPoints.map((controlPoint) => {
                        let colorMarker = controlPoint.status === 1 ? "green" : "#757575";
                        colorMarker = controlPoint.status > 1 ? "red" : colorMarker;

                        return (
                          <div key={controlPoint.id}>
                            <Marker
                              draggable={false}
                              icon={this.getIcon(colorMarker, orderCountControlPoint++)}
                              position={[controlPoint.latitude, controlPoint.longitude]}
                            >
                              <Circle
                                color={colorMarker}
                                key={`${controlPoint.radius} ${controlPoint.latitude} ${controlPoint.longitude}`}
                                center={[controlPoint.latitude, controlPoint.longitude]}
                                radius={Number(controlPoint.radius)}
                              >
                                <Popup className="mapPopup">
                                  <div className="mapPopupContent">
                                    <b>Транспортное средство: </b> <span> {unit.title}</span>
                                  </div>

                                  <div className="mapPopupContent">
                                    <b>Регистрационный номер: </b> <span> {unit.registerNumber}</span>
                                  </div>

                                  <div className="mapPopupContent">
                                    <span>
                                      Посещено:{" "}
                                      {!controlPoint.timeEvent.includes("0001-01-01")
                                        ? getDates.getDateFormat9(controlPoint.timeEvent)
                                        : ""}
                                    </span>
                                  </div>

                                  <div className="mapPopupContent">
                                    <span>Наименование контрольной точки: {controlPoint.title}</span>
                                  </div>
                                  <div className="mapPopupContent">
                                    <span>Адрес: {controlPoint.address}</span>
                                  </div>
                                  <div className="mapPopupContent">
                                    <span>Адрес по локации: {controlPoint.geocoderAddress}</span>
                                  </div>

                                  {controlPoint.description !== null && controlPoint.description !== undefined ? (
                                    <div className="mapPopupContent">
                                      <span>Описание: {controlPoint.description}</span>
                                    </div>
                                  ) : null}

                                  <div className="mapPopupContent">
                                    <span>Радиус: {controlPoint.radius} м.</span>
                                  </div>
                                  <div className="mapPopupContent">
                                    <span>Максимальная скорость: {controlPoint.maxSpeed} км./ч.</span>
                                  </div>
                                </Popup>
                              </Circle>
                            </Marker>
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            );
          })}

          {monitoringTaskTrip.units.map((unit) => {
            const isView = viewUnits.some((x) => {
              return x.id === unit.id && x.isView;
            });

            if (!isView || unit.mapPositions.routes.length === 0) return null;

            const startPoint = unit.mapPositions.routes[0].positions[0];

            const lastRouteIndex = unit.mapPositions.routes.length - 1;
            const finishPoint =
              unit.mapPositions.routes[lastRouteIndex].positions[unit.mapPositions.routes[lastRouteIndex].positions.length - 1];

            return (
              <div key={unit.id}>
                <div>
                  <MapMarkerTaskTrip point={startPoint} title={"Начало"} unit={unit} />
                  <MapMarkerTaskTrip point={finishPoint} title={"Конец"} unit={unit} />
                </div>

                {unit.mapPositions.routes.map((route, index) => {
                  return (
                    <div key={index}>
                      <AntPath
                        positions={route.positions.map((item) => {
                          return [item.location.lat, item.location.long];
                        })}
                        options={{
                          delay: 1000,
                          dashArray: [30, 200],
                          weight: 3,
                          color: "#3388ff",
                          opacity: 1,
                          pulseColor: "#FFFFFF",
                          hardwareAccelerated: true,
                        }}
                        eventHandlers={{
                          click: (e) => {
                            console.log(e);
                          },
                        }}
                      >
                        {/*          <Popup className="mapPopup" /> */}
                      </AntPath>
                    </div>
                  );
                })}
              </div>
            );
          })}

          {this.props.children}
        </MapContainer>

        <TopRightMapControl>
          <div className={styles.overlayer_control_container}>
            {isOverlayerControlOpen ? (
              <div className={styles.overlayerOpenContainer}>
                <TooltipWrapper title={"Закрыть панель объектов"} position="left">
                  <div className={styles.layersIconControlClose} onClick={() => this.setState({ isOverlayerControlOpen: false })}>
                    <HighlightOffIcon fontSize="small" />
                  </div>
                </TooltipWrapper>

                <TooltipWrapper title={`${isControlPointsView ? "Скрыть" : "Показать"} контрольные точки`} position="left">
                  <div
                    className={isControlPointsView ? styles.checkbox_layer : styles.checkbox_layer_disable}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.setState({ isControlPointsView: !isControlPointsView });
                    }}
                  >
                    <span className={styles.statuses_container}>Контрольные точки</span>
                  </div>
                </TooltipWrapper>

                <TooltipWrapper title={`${isRouteGeometryView ? "Скрыть" : "Показать"} расчитанный маршрут рейса`} position="left">
                  <div
                    className={isRouteGeometryView ? styles.checkbox_layer : styles.checkbox_layer_disable}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.setState({ isRouteGeometryView: !isRouteGeometryView });
                    }}
                  >
                    <span className={styles.statuses_container}> Расчитанный маршрут рейса</span>
                  </div>
                </TooltipWrapper>

                {viewUnits.map((unit) => {
                  return (
                    <TooltipWrapper key={unit.id} title={`${unit.isView ? "Скрыть" : "Показать"} ${unit.title}`} position="left">
                      <div
                        className={unit.isView ? styles.checkbox_layer : styles.checkbox_layer_disable}
                        onClick={(e) => {
                          e.stopPropagation();
                          this.onChangeUnitView(unit.id, !unit.isView);
                        }}
                      >
                        <span className={styles.statuses_container}>
                          {" "}
                          {unit.title} {unit.registerNumber}
                        </span>
                      </div>
                    </TooltipWrapper>
                  );
                })}
              </div>
            ) : (
              <TooltipWrapper title={"Открыть панель объектов"} position="left">
                <div className={styles.layersIconControl} onClick={() => this.setState({ isOverlayerControlOpen: true })}>
                  <LayersIcon />
                </div>
              </TooltipWrapper>
            )}
          </div>

          <BaseLayerMapControl />
        </TopRightMapControl>
      </div>
    );
  }
}

export default withAppState(withMapControl(withMonitoringTaskTrips(React.memo(UnitsTaskTripMap))));
